/* @flow */
import type { Action, AsyncAction, FindSmartlistParams } from 'types';

import liferay from 'services/liferay';

const onFailure = (error: Object) => console.warn(error);

const fetchFeaturedList = (params: FindSmartlistParams): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'FETCH_FEATURED_LIST_REQUEST',
    payload: params,
    promise: liferay.featured.find(params),
    meta: { onFailure },
  };
};

const featuredSetPageScroll = (pageScroll: number): Action => {
  return {
    type: 'FEATURED_SCROLL_PAGE',
    payload: pageScroll,
  };
};

export default {
  fetchFeaturedList,
  featuredSetPageScroll,
};
